import { render, staticRenderFns } from "./TabsHeader.vue?vue&type=template&id=216a1a9c&scoped=true&"
import script from "./TabsHeader.vue?vue&type=script&lang=ts&"
export * from "./TabsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TabsHeader.vue?vue&type=style&index=0&id=216a1a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a1a9c",
  null
  
)

export default component.exports